import { useCallback, useEffect, useState } from 'react';
import { getNestJsonUrl } from '../config/app';

export function useNestPair() {
    const [title, setTitle] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(getNestJsonUrl(), { cache: 'no-store' });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            setTitle(typeof json.title === 'string' ? json.title : '');
            setStatus(typeof json.status === 'string' ? json.status : '');
        } catch (e) {
            setError(e.message || 'Błąd');
            setTitle('');
            setStatus('');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { title, status, loading, error, reload: load };
}
